const STEPS = [
  {
    icon: 'ri-settings-3-line',
    title: '开启省流画质',
    desc: '进入「设置 → 省流画质」，选择自动或固定低流量档位，漫画图片将以更节省的方式加载。',
  },
  {
    icon: 'ri-stack-line',
    title: '打开压缩图模式',
    desc: '在省流设置中打开压缩图模式，压缩下载图片体积，单章更轻，缓存占用也更少。',
  },
  {
    icon: 'ri-wifi-line',
    title: '设置仅WiFi下载',
    desc: '开启仅WiFi下载，批量缓存只走无线网络，用移动流量也能放心畅读不跑量。',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: '随时查看流量监控',
    desc: '回到流量监控页面，查看每话每部的消耗明细，掌握省流效果，及时调整设置。',
  },
];

export default function HowTo() {
  return (
    <section id="guide" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-guide-line"></i>
              三步轻松省流量
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
              漫画人极速版怎么省流量？
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              不需要懂复杂的网络设置，照着以下几步操作，就能开启完整的数据节省方案，
              从此低流量浏览漫画更安心。
            </p>
            <a
              href="#faq"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-secondary-300 px-4 py-2 text-sm font-medium text-secondary-800 transition-colors hover:bg-secondary-50"
            >
              还有疑问？查看常见问题
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <ol className="relative space-y-4">
            {STEPS.map((step, idx) => (
              <li key={step.title} className="relative flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-500 text-xs text-background-50">
                      {idx + 1}
                    </span>
                    {step.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}